// rAF-based fixed-timestep tick loop. Bounds dt so a tab-switch doesn't fire
// a huge dt that breaks game state.

export type LoopFn = (dt: number) => void;

export class GameLoop {
  private rafId: number | null = null;
  private last = 0;
  private running = false;
  private readonly maxDt: number;
  private readonly tickFn: LoopFn;

  constructor(tickFn: LoopFn, maxDt = 0.1) {
    this.tickFn = tickFn;
    this.maxDt = maxDt;
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    const loop = (now: number) => {
      if (!this.running) return;
      const dt = Math.min(this.maxDt, (now - this.last) / 1000);
      this.last = now;
      this.tickFn(dt);
      this.rafId = requestAnimationFrame(loop);
    };
    this.rafId = requestAnimationFrame(loop);
  }

  stop(): void {
    this.running = false;
    if (this.rafId !== null) cancelAnimationFrame(this.rafId);
    this.rafId = null;
  }

  get isRunning(): boolean {
    return this.running;
  }
}
